import React from "react";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";

// const techs = ["node", "react", "express", "firebase"];
export const Project = (props) => {
	return (
		<Card
			border="primary"
			style={{
				marginBottom: "1vh",
				backgroundColor: "rgb(41,44,47)",
			}}
		>
			<Card.Img
				className="CardImg"
				variant="top"
				src={props.project.img}
				style={{ height: "40vh" }}
			/>

			<Card.Body>
				<Card.Title>
					{props.language === "eng"
						? props.project.title.eng
						: props.project.title.pl}
				</Card.Title>
				<Card.Subtitle className="mb-2">
					{props.project.tech.map((tech) => tech + " ")}
				</Card.Subtitle>
				<Card.Text style={{ fontSize: "small" }}>
					{props.language === "eng"
						? props.project.description.eng
						: props.project.description.pl}
				</Card.Text>
				{props.project.link ? (
					<Button
						variant="dark"
						style={{ fontSize: "small" }}
						onClick={() => {
							window.open(props.project.link, "_blank");
						}}
					>
						{props.language === "eng"
							? "Navigate to site"
							: "Przejdź do strony"}
					</Button>
				) : null}
				{props.project.git ? (
					<Button
						variant="dark"
						style={{ fontSize: "small" }}
						onClick={() => {
							window.open(props.project.git, "_blank");
						}}
					>
						GIT
					</Button>
				) : null}
			</Card.Body>
		</Card>
	);
};



// WEBPACK FOOTER //
// ./src/components/Project.js